import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { layerNodesKeys } from './queryKeys';
import type {
  ListLayerNodesFilter,
  ListLayerNodesQuery,
  ListLayerNodesResponse,
} from './types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export function useListLayerNodes(
  query: ListLayerNodesQuery,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: layerNodesKeys.list(query),
    queryFn: async () => {
      const resp = await axios.get<ListLayerNodesResponse>(
        config.apiGateway.layer_nodes,
        { params: buildSearchQueryParams<ListLayerNodesFilter>(query) }
      );
      return resp.data;
    },
    enabled: options?.enabled ?? true,
  });
}
